import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Modal } from "react-bootstrap";
import { PencilSquare, Trash, Check, X } from "react-bootstrap-icons";


// ------------ Page Imports ---------------

import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyDelete, companyEdit, projectPost, projectGet, teamGet, projectEdit, projectDelete } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const Project = () => {
  const [apiData, setApiData] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    project_name: "",
    project_location: "",
    description: "",
    team_id: 0
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleitingId, setDeletingId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    project_name: "",
    project_location: "",
    description: "",
    team_id: 0
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await projectGet();
        if (data.results) {
          const project = data.results.map(i => ({
            id: i.project_id,
            project_name: i.project_name,
            project_location: i.project_location,
            description: i.description,
            team_id: i.team_id
          }));
          setApiData(project);
          setIsLoading(false);
          console.log(`API Data ${JSON.stringify(apiData)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const fetchTeams = async () => {
      try {
        const data = await teamGet();
        if (data) {
          const team = data.results.map(i => ({
            team_id: i.team_id,
            team_name: i.team_name,
            description: i.description,
            companyId: i.company_id,
          }));
          setTeams(team);
          console.log(team)
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Team Data: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchData();
    fetchTeams();
  }, [])

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    console.log(`Project Form Data: ${JSON.stringify(formData)}`);

    e.preventDefault();
    setShowAddModal(false)
    try {
      const response = await projectPost(formData);
      if (response) {
        alert("Project Created");
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
    setFormData({
      project_name: "",
      project_location: "",
      description: "",
      team_id: null
    });
  }


  const handleEditClick = (projectData) => {
    setShowEditModal(true);
    setEditFormData({
      project_name: projectData.project_name,
      project_location: projectData.project_location,
      description: projectData.description,
      team_id: projectData.team_id
    });
  };
  const handleCancelClick = () => {
    setEditingId(null);
  }


  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({
      ...editFormData,
      [name]: value
    });
  };

  const handleEditSubmit = async () => {
    console.log('Editing ID: ', editingId);
    
    setShowEditModal(false);
    try {
      const response = await projectEdit(editFormData, editingId);
      if (response) {
        // setEditingId(null)
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Update Data in Project: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await projectDelete(id)
      if (response) {
        setDeletingId(null);
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Deleting Data in Project: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Projects"
          showButtons={true}
        />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Project Details
          <Button variant="primary" className="d-flex align-items-center" onClick={() => setShowAddModal(true)}>
            Create+
          </Button>
        </h4>
        {isLoading ? <div class="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div> :
          <div style={{ overflow: 'auto' }}>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th className="fs-12">Project Name</th>
                  <th className="fs-12">Project Location</th>
                  <th className="fs-12">Description</th>
                  <th className="fs-12">Team</th>
                  <th className="fs-12">Actions</th>
                </tr>
              </thead>
              <tbody>
                {apiData.map((projectData, i) => (
                  <tr key={projectData.id}>
                    <td className="fs-12">{projectData.project_name}</td>
                    <td className="fs-12">{projectData.project_location}</td>
                    <td className="fs-12">{projectData.description}</td>
                    <td className="fs-12">
                      {teams.find(team => team.team_id === projectData.team_id)?.team_name || 'N/A'}
                    </td>
                    <td className="fs-12">
                      <Button variant="outline-primary" size="sm" onClick={() => {
                        setEditingId(projectData.id)
                        handleEditClick(projectData)
                      }} >
                        <PencilSquare />
                      </Button >
                      <Button variant="outline-primary" size="sm" onClick={() => {
                        setDeletingId(projectData.id)
                        setShowDeleteModal(true)
                      }} >
                        <Trash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        }
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Create New Project</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="project_name">
                <Form.Label>Project Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="project_name"
                  value={formData.project_name}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="project_location">
                <Form.Label>Project Location*</Form.Label>
                <Form.Control
                  type="text"
                  name="project_location"
                  value={formData.project_location}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description*</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="team_id">
                <Form.Label>Team Name</Form.Label>
                <Form.Select
                  name="team_id"
                  value={formData.team_id}
                  onChange={handleFormChange}
                  style={{ height: '38px' }}
                >
                  <option value=''>Select Team</option>
                  {teams.map(i => (
                    <option key={i.team_id} value={i.team_id}>{i.team_name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={() => setShowAddModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Project Edit Modal */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Update Project</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="project_name">
                <Form.Label>Project Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="project_name"
                  value={editFormData.project_name}
                  onChange={handleEditFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="project_location">
                <Form.Label>Project Location*</Form.Label>
                <Form.Control
                  type="text"
                  name="project_location"
                  value={editFormData.project_location}
                  onChange={handleEditFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description*</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={editFormData.description}
                  onChange={handleEditFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="team_id">
                <Form.Label>Team Name</Form.Label>
                <Form.Select
                  name="team_id"
                  value={editFormData.team_id}
                  onChange={handleEditFormChange}
                  style={{ height: '38px' }}
                >
                  <option value=''>Select Team</option>
                  {teams.map(i => (
                    <option key={i.team_id} value={i.team_id}>{i.team_name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={() => setShowEditModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleEditSubmit}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Congirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are You Want to delete This Project?..</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>NO</Button>
            <Button variant="warning" onClick={() => {
              handleDelete(deleitingId);
              setShowDeleteModal(false);
            }}>YES</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
};

export default Project;